import React, { Component } from "react";
import { Button, Collapse, Divider, Card, Modal } from "antd";
import { Link } from "react-router-dom";
import bus from '@utils/bus';

const Panel = Collapse.Panel;
const customPanelStyle = {
    background: '#f0f2f5',
    borderRadius: 4,
    border: 0,
    overflow: 'hidden',
};
export default class Help extends Component {

    state = {
    };

    componentWillUnmount() { }

    componentWillMount() { }

    showExample = (name) => {
        Modal.info({
            title: '示例图片',
            width: name === 'example_1' ? 980 : 1000,
            okText: '关闭',
            content: (
                <div>
                    <img src={require(`../../assets/Images/${name}.png`)} alt="" height={600} />
                </div>
            ),
            onOk() { },
        });
    };

    render() {
        return (
            <div>
                <h2 style={{ marginTop: 8 }}>接入帮助</h2>
                <p className="paragraph" style={{ paddingLeft: 12 }}><span className="warning">请与渠道管理员索要游戏的AppID</span></p>
                <Collapse bordered={false} defaultActiveKey={["1", "2", "3", "4"]}>
                    <Panel header={<h3>接入方式一&nbsp;&nbsp;&nbsp;&nbsp;配置公众号自定义菜单</h3>} key="1" style={customPanelStyle} showArrow={false}>
                        <Divider style={{ background: '#555', margin: 0 }} />
                        <p className="paragraph">第一步: 关联小程序</p>
                        <p className="paragraph"><span className="warning">关联时，取消关联后展示在公众号资料页勾选项，取消关联后给已关注公众号的用户发送通知勾选项。</span></p>
                        <p className="paragraph"><Button onClick={() => { this.showExample('example_1') }} type="primary">配置示例查看</Button></p>
                        <p className="paragraph">第二步: 添加小游戏到菜单栏</p>
                        <p className="paragraph"><Button onClick={() => { this.showExample('example_2') }} type="primary">配置示例查看</Button></p>
                    </Panel>
                    <Panel header={<h3>接入方式二&nbsp;&nbsp;&nbsp;&nbsp;小程序跳转小游戏</h3>} key="2" style={customPanelStyle} showArrow={false}>
                        <Divider style={{ background: '#555', margin: 0 }} />
                        <p className="paragraph">通过小程序API <span className="warning">wx.navigateToMiniProgram</span>跳转到小游戏，接口参数配置如下：</p>
                        <Card style={{ width: 300, background: '#e8e8e8', marginTop: 10 }}>
                            <p>{'//关键参数配置代码'}</p>
                            <p>path="?channel=渠道号"</p>
                        </Card>
                    </Panel>
                    <Panel header={<h3>接入方式三&nbsp;&nbsp;&nbsp;&nbsp;小游戏跳转小游戏</h3>} key="3" style={customPanelStyle} showArrow={false}>
                        <Divider style={{ background: '#555', margin: 0 }} />
                        <p className="paragraph">通过小程序二维码，或通过小游戏API <span className="warning">wx.navigateToMiniProgram</span>跳转到小游戏，接口参数配置如下：</p>
                        <Card style={{ width: 300, background: '#e8e8e8', marginTop: 10 }}>
                            <p>{'//关键参数配置代码'}</p>
                            <p>path="?channel=渠道号"</p>
                        </Card>
                    </Panel>
                    <Panel header={<h3>接入方式四&nbsp;&nbsp;&nbsp;&nbsp;小程序推广二维码推广</h3>} key="4" style={customPanelStyle} showArrow={false}>
                        <Divider style={{ background: '#555', margin: 0 }} />
                        <p className="paragraph">
                            在此系统中
                            <Link to={"QRcode"} className="link" >
                                <span onClick={() => { bus.dispatch('menuRedirect', '/cps/QRcode') }}>生成推广二维码</span>
                            </Link>
                            提供给与您合作的商户
                        </p>
                    </Panel>
                </Collapse>
            </div>
        );
    }
}
